export const splitColumns = (
    arr: Array<{ key: string; url: string }>,
    columnCount: number,
) => {
    const size = Math.ceil(arr.length / columnCount);
    return Array.from({ length: columnCount }, (v, i) =>
        arr.slice(i * size, i * size + size),
    );
};
